import { apiList } from "../api/apiList";
import axiosInstance2 from "../api/axiosInstance2";

const bettingService = {
  getLiveBettingMatch: (payload) => axiosInstance2.post(apiList.getLiveBettingApi,payload),
  getSingleInsightMatch: (payload) => axiosInstance2.post(apiList.getSingleInsightApi,payload),
  getBetDetails: (gamblingId) => axiosInstance2.get(`${apiList.getBetDetailsApi}/${gamblingId}`),
//   getEventMatch: () => axiosInstance.get(apiList.eventMatchApi),
//   editEventMatch: (id,payload) => axiosInstance.put(`${apiList.eventMatchApi}/${id}`, payload),
}

export default bettingService;
